import {ActiveField} from '../ActiveField'

export default class TreeSelectField extends ActiveField {
  constructor () {
    // @ts-ignore
    super(...arguments)
    this.fieldType = 'tree-select'
  }
}